import React, { useState, useEffect } from 'react';
import axios from 'axios';
import globalStyles from '../../utils/globalStyles'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { useForm, Controller } from 'react-hook-form'
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom'
import { List, Box, Typography, Input, Select, MenuItem, Button, Divider, Menu, FormControl, FormGroup, Checkbox, Radio, FormControlLabel, RadioGroup, 
TableContainer, Table, TableHead, TableBody, TableRow, Paper, Modal,Pagination } from '@mui/material'  
import legolasApi from '../../api/legolas'

const WinterOrderList = () => {
  const [totalCount, setTotalcount] = React.useState(0);
  const [orderData, setOrderData] = useState([]);
  const [currentPage, setCurrentPage] = React.useState(1)
  const [filterArray, setFilterArray] = React.useState([])
  const [searchString, setSearchstring] = React.useState('')
  const [columnsOpen, setColumnsOpen]= React.useState(false)
  const [anchorCol, setAnchorCol] = React.useState(null)
  const [listData, setListData] = React.useState([]);
  const navigate = useNavigate()

  const fetchAll = {
  };

  const clearFilterArray = () => {
    setFilterArray([]);
    handlePagination('', 1);
  }

  const handleColumnClick = (e) =>  {
    setColumnsOpen(true)
    setAnchorCol(e.currentTarget)
  }


  const handlePagination = (event, value) => {
    const offset = value - 1;
    const url = `${legolasApi.url}/orders/winterorder/list?offset=${offset}&search=${searchString}`;
    
    axios.get(url)
      .then((res) => {
        setCurrentPage(value);
        setListData(res.data.data);
      })
      .catch((error) => console.log('Error in getting orders: ', error));
  };
  
  
  
  
  const handleEditClick = (order) => {
    const redirectUrl = `/orders/winterorders/${order.order_id}`
    navigate(redirectUrl, { state: { data: order }})
  }

  const handleSearch = () => {
    console.log('njbednjebndjenend')

    const searchQuery = { search : searchString };
    axios.get(`${legolasApi.url}/orders/winterorder/list`, { params: searchQuery })
      .then((res) => {
        console.log('data', res)

        const data = res.data.data || [];
        const count = res.data.data.length || 0;
        setListData(data);
        setTotalcount(count);
        setCurrentPage(1);
      })
      .catch((error) => console.log('Error in getting orders: ', error));
  };
  
  

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' +  year + '  ' + formattedTime
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#2b3f7a',
      color: theme.palette.common.white,
      padding: globalStyles.common.infoTablesPadding,
      borderRight: '2px solid #fff',
      whiteSpace: 'nowrap',
      borderRadius: '0px !important'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: globalStyles.common.infoTablesPadding,
      borderRadius: '0px !important'
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const [selectedHeaders, setSelectedHeaders] = React.useState([
    {id: 'order_id', label: 'Order ID'},{id: 'order_status', label: 'Order Status'},
    {id: 'parent_email', label: 'Parent Email'}, {id: 'parent_name', label: 'Parent Name'},, 
    {id: 'parent_phone', label: 'Parent Phone' },{id: 'parent_relationship', label: 'Parent Relationship'},
    {id: 'total_sibling_count', label: 'Total Children Count'},
    {id: 'grand_total', label: 'Grand Total'},{id: 'created_at', label: 'Created At'},
  ])
  
  useEffect(() => {
    axios.get(`${legolasApi.url}/orders/winterorder/list`, fetchAll)
      .then((res) => {
        const data = res.data.data.orders, count = res.data.data.count
        setListData(res.data.data);
        setTotalcount(count)

        console.log('API Response:', res);

      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []); 

  return (
    <React.Fragment>
              <List actions={null}>

        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Winter Camp Orders</Typography>
          </Box>
        </Box>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ 
              width: '100%', 
              display: 'flex', 
              margin: '0px 30px',
              '& .MuiInput-input': {
                width: '300px !important',
                padding: '5px 10px !important'
              },
              '& .MuiSvgIcon-root': {
                paddingRight: '10px'
              },
              justifyContent: 'space-between'
            }}>
              <Input
                type='search' 
                sx={{ border: '1px solid #2b3f7a', borderRadius: '20px' }} 
                endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()}/>} 
                placeholder='Seach by Order ID'
                onChange={(e) => setSearchstring(e.target.value)}
              />
              </Box>
        </Box>

    <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
              <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                <TableRow>
                  {selectedHeaders.map((header) => [
                    <StyledTableCell align='center'>{header.label}</StyledTableCell>
                  ])}
                  <StyledTableCell align='center'> Details </StyledTableCell>
                  {/* <StyledTableCell align='center'>Delete</StyledTableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                
              {listData && listData.map((order) => (
                      <StyledTableRow key={order.id} >
                          <StyledTableCell align="center" >{order.order_id}</StyledTableCell>
                          <StyledTableCell align="center" >{order.order_status === 2 ? 'Payment Sucessfull' : [6,7].includes(order.order_status) ? 'Dropped Registration' : 'Payment Failed'}</StyledTableCell>
                          {/* <StyledTableCell align="center" >{data.fk_payment_id}</StyledTableCell> */}
                          <StyledTableCell align="center" >{order.parent_email}</StyledTableCell>
                          <StyledTableCell align="center" >{order.parent_name}</StyledTableCell>
                          <StyledTableCell align="center" >
                                  {order.parent_phone.length > 15 ? `${order.parent_phone.slice(0, 15)}...` : order.parent_phone}
                          </StyledTableCell>
                          <StyledTableCell align="center" >{order.parent_relationship}</StyledTableCell>
                          <StyledTableCell align="center" >{order.total_sibling_count}</StyledTableCell>
                          {/* <StyledTableCell align="center" >{order.coupon_code ? order.coupon_code:'N/A'}</StyledTableCell> */}
                          <StyledTableCell align="center" >{order.grand_total}</StyledTableCell>
                          {/* <StyledTableCell align="center" >{order.discount_amount}</StyledTableCell> */}
                          <StyledTableCell align='center' >{formatDateAndTime(new Date(order.created_at))}</StyledTableCell>
                          
                        <StyledTableCell align='center'>
                          <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => handleEditClick(order)}/>
                        </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ justifyContent: 'center' }}>
          <Pagination count={Math.ceil(totalCount/20)} page={currentPage} onChange={handlePagination} />
          </Box>
        </List>
    </React.Fragment>
    );
};

export default WinterOrderList;
